var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 144,
    viewBox: "0 0 145 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 72.5,
    cy: 72,
    r: 72,
    fill: "#F70000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M98.903 97.9293C99.9175 96.9219 99.9204 95.2818 98.9094 94.2708L51.4587 46.8196C50.4538 45.8147 48.8245 45.8147 47.8195 46.8196C46.8146 47.8245 46.8146 49.4538 47.8195 50.4587L50.0005 52.6397C49.6133 53.3624 49.4069 54.1883 49.4069 55.0658L49.381 86.0375C49.381 88.9024 51.6781 91.1994 54.5429 91.1994H88.534L95.2574 97.9229C96.2633 98.9288 97.8935 98.9317 98.903 97.9293ZM54.5429 70.5516V60.2278H57.5626L67.8864 70.5516H54.5429ZM61.847 49.9039H95.8381C98.703 49.9039 101 52.2009 101 55.0658V86.0375C101 86.915 100.794 87.7409 100.406 88.4636L82.4946 70.5516H95.8381V60.2278H72.1708L61.847 49.9039Z",
    fill: "#F70000"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteCard);
export default __webpack_public_path__ + "static/media/DeleteCard.b91a84a33f4496760c95310a3979931e.svg";
export { ForwardRef as ReactComponent };